(function ($, njm) {
    'use strict';

    njm.views.njmsharesVideos = Backbone.View.extend({

        /**
         * Initialize
         */
        initialize: function () {
            $('.videos_modal').hide();
            $('.comp-njmshares-videos #video1').click(function () {
                $('.videos_modal').fadeIn();

                $('.videos_modal iframe').attr('src', 'https://www.youtube.com/embed/IjUoIaOBhAY');
            });

            $('.comp-njmshares-videos #video2').click(function () {
                $('.videos_modal').fadeIn();

                $('.videos_modal iframe').attr('src', 'https://www.youtube.com/embed/RicJxEVlEmg');
            });

            $('.comp-njmshares-videos #video3').click(function () {
                $('.videos_modal').fadeIn();

                $('.videos_modal iframe').attr('src', 'https://www.youtube.com/embed/p1CXXDBg8S0');
            });

            $('#modal_close').click(function () {
                $('.videos_modal').fadeOut();

                $('.videos_modal iframe').attr('src', '');
            });

            $('.videos_modal').click(function () {
                $('.videos_modal').fadeOut();

                $('.videos_modal iframe').attr('src', '');
            });
        }
    });
})(jQuery, njm);
